import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import '../../Placement.css';
import bannerImage from "../../Images/Banner/university.webp";
import img2 from '../../Images/placement/placement3.webp';
import { Container, Row, Col } from 'react-bootstrap';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CareerCounselling = () => {

    const body = [
        {
            name: "Comprehensive career guidance solutions for students, parents, educators and schools.",
        },
        {
            name: "Enable students to identify their best-fit career with our world-class career assessment and personalised guidance.",
        },
        {
            name: "Empower students to learn all about the professional world with virtual career simulations, exhaustive career library.",
        },
        {
            name: "Pave student’s way to their dream college with our end-to-end college application guidance, scholarship drive and corporate internship program.",
        },
        {
            name: "Enable schools in creating a career guidance ecosystem in sync with the vision of New Education Policy",
        },
        {
            name: "Empower educators to become International Certified Career Coaches and build a career in career guidance & counseling",
        },
        {
            name: "Revolutionary assessment platform and technology driven career guidance solutions for educators to boost their career guidance & counselling practice",
        },
    ];

    const sliderSettings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992, // tablets
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768, // mobile
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };
    return (
        <>
            <title>ISBM University Career Counselling | Explore Your Future</title>
            <meta
                name="description"
                content="Unlock your career potential with ISBM University's expert counselling services. Receive personalized advice to align your strengths with the right career path."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="conatiner-xxl">
                        <div className="section-hero-content">
                            <h1>Career Counselling</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Career Counselling
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            {/* Training */}
            <section className="container-xxl ptb-50">
                <Row className="flex-wrap-reverse">
                    {/* Job List Section */}
                    <div className="col-md-6 d-flex justify-content-center">
                        <div className="students-gallery-section">
                            <div className="gallery-grid">
                                <div className="background-block"></div>
                                <div className="gallery-item large">
                                    <img src={img2} alt="Group 1" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Col md={6}>
                        <div className="row align-items-center">
                            <div className="p-4">
                                <h2 className="modern-title text-blue">
                                    Career Counselling
                                </h2>
                                <div className="underline-divider mb-3"></div>
                                <p>
                                    There are hundreds of careers options, multiple stream combinations and endless career paths.
                                    ISBM University help you choose your right path like the thousands of students we have helped !
                                </p>
                                <p>
                                    Career Counseling is a process that will help you to know and understand yourself and the world of
                                    work in order to make career, educational, and life decisions. Career development is more than just
                                    deciding on a major and what job you want to get when you graduate.
                                </p>
                                <p>Whether you are a student or recent grad or at the midpoint of your career trajectory and thinking about
                                    a career change, career counseling could help you make sound decisions for your professional journey.
                                </p>
                                <p>ISBM University helps students discover perfect career through its multi dimensional career assessment,
                                    and revolutionary approach to career counselling and career guidance.
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </section>

            <section className="career">
                <div className="container-xxl py-5">
                    <Slider {...sliderSettings}>
                        {/* Slide 1 */}
                        <div className="px-3">
                            <div className="coCol1 h-100">
                                <figure>
                                    <h2 className="black_title">Career Counselling</h2>
                                </figure>
                                <p>
                                    It is the process of giving advice, support and guidance for selecting the right stream after class 10th,
                                    and the right career after 12th and graduation and during the graduation and post graduation also.
                                    Career confusion and indecision can affect you at any stage of your career, thus it is important to
                                    get the right support to resolve it and plan ahead. Career Counsellors in ISBM University let you explore
                                    different career options, their scope, colleges and opportunities, and help you make the right career choice.
                                    With a competent team of career counsellors, you can rest assured that you’ll get the most reliable advice and
                                    guidance for your career.
                                </p>
                            </div>
                        </div>

                        {/* Slide 2 */}
                        <div className="px-3">
                            <div className="coCol1 h-100">
                                <figure>
                                    <h2 className="black_title">Career Assessments</h2>
                                </figure>
                                <p>
                                    A Career Assessment is a test designed to understand where your unique set of strengths,
                                    aptitudes and skills lie, in order to recommend the right careers for you. ISBM University Career
                                    Assessment team organizes an online career test that evaluates students on various parameters across different
                                    dimensions including Personality, Aptitude, Interest, EQ and Orientation Style, to suggest top career options.
                                    Not only that, students get detailed career development plans and expert guidance within a comprehensive career
                                    report itself, so candidates can take the first step towards achieving their career goals.
                                </p>
                            </div>
                        </div>

                        {/* Slide 3 */}
                        <div className="px-3">
                            <div className="coCol1 h-100">
                                <figure>
                                    <h2 className="black_title">Career Guidance</h2>
                                </figure>
                                <p>
                                    Career Guidance takes the benefits of career assessments and career counselling to the next level.
                                    It is the process where a career guide helps you on your path to career development and career success.
                                    Being successful in a career takes extensive efforts, and with an experienced coach/mentor, your career
                                    development efforts can find the right direction. Career counselors at ISBM University provide career guidance
                                    by building customized career action plans and road map, direct students back to the right path, provide personalized
                                    24x7 support, and help them at every step along the way to a successful career.
                                </p>
                            </div>
                        </div>
                    </Slider>
                </div>
            </section>

            <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center modern-title text-blue">Shaping the Career Guidance Landscape</h2>
                    <div className="underline-center mb-5 mx-auto"></div>
                    <div className="row m-0">
                        {body.map((member, index) => (
                            <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                    <div className="visahead">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="text-dark mb-0">{member.name}</h5>
                                            <span className="badge designation ms-2 ">
                                                {member.designation}
                                            </span>
                                        </div>
                                        <div className="underlinetwo"></div>
                                    </div>
                                    <ul className="mb-0 list-unstyled">
                                        <li>{member.remarks}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default CareerCounselling;
